module.exports = "<i *ngIf=\"isCustomViewDescriptionEnabled(view)\" class=\"fa fa-info-circle fa-1 view-desc\"><span class=\"desc\">{{getCustomViewDescription(view)}}</span></i>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-view-desc-bubble/usc-view-desc-bubble.component.html
// module id = ../../../../../src/app/components/usc-store/usc-view-desc-bubble/usc-view-desc-bubble.component.html
// module chunks = main